import { IMG_BASE_PATH } from '@/const'

export function FormImagePreview({ imageKey }: { imageKey?: string | null }) {
  if (!imageKey || imageKey === 'None' || imageKey === '') return null
  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-sm font-medium">Selected image preview:</div>
      <div className="flex h-36 w-full items-center justify-center rounded-lg border bg-background p-5">
        <img className="h-full object-contain" src={`${IMG_BASE_PATH}${imageKey}`} alt="Selected Image" />
      </div>
    </div>
  )
}
